export const BookingChannel = {
  ONLINE: 'online',
  MANUAL: 'manual',
} as const;
export type BookingChannel =
  (typeof BookingChannel)[keyof typeof BookingChannel];

const CHANNEL_ROLE_PREFIX = 'booking-channel:';

export interface Scopes {
  'booking.channels': readonly BookingChannel[];
}
export type ScopeKey = keyof Scopes;

export const EMPTY_SCOPES: Scopes = { 'booking.channels': [] };

export const ALL_SCOPES: Scopes = {
  'booking.channels': [BookingChannel.ONLINE, BookingChannel.MANUAL],
};

export function channelFromRole(role: string): BookingChannel | null {
  if (!role.startsWith(CHANNEL_ROLE_PREFIX)) return null;
  const value = role.slice(CHANNEL_ROLE_PREFIX.length);
  return value === BookingChannel.ONLINE || value === BookingChannel.MANUAL
    ? value
    : null;
}
